export default __webpack_public_path__ + "static/media/ip-select-indicator.bd531c34.svg";